import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function Header() {
  const location = useLocation();
  
  const isActive = (path) => {
    if (path === '/learner') {
      return location.pathname.startsWith('/learner');
    }
    return location.pathname === path;
  };

  return (
    <header className="header">
      <div className="header-inner">
        <Link to="/" className="header-logo">
          The Navigational <span>Mind</span>
        </Link>
        <nav className="header-nav">
          <Link 
            to="/learner" 
            className={isActive('/learner') ? 'active' : ''}
          >
            Course
          </Link>
          <Link 
            to="/practitioner" 
            className={isActive('/practitioner') ? 'active' : ''}
          >
            Practitioner
          </Link>
          <Link 
            to="/resources" 
            className={isActive('/resources') ? 'active' : ''}
          >
            Resources
          </Link>
          <Link to="/tutor" className="tutor-button">
            <span>✦</span> AI Tutor
          </Link>
        </nav>
      </div>
    </header>
  );
}

export default Header;
